import { getTwolevelAuthrity } from "common/js/storage";

/* 权限列表数据 */
const OPERATION_LIST = getTwolevelAuthrity()


/* 页面按钮*/
const OPERATIONS_BTNS = {
  //待分配 
  roleFreeUser: "ROLE_FreeUser",
  //借调（借调和借调确认）
  roleOnLoanOnLoanConfirm: "ROLE_OnLoanOnLoanConfirm",
  //变更部门
  roleChangeDept: "ROLE_ChangeDept",
  //用户编辑
  roleUpdateUser: "ROLE_UpdateUser",
  //部门编辑（包含删除、编辑、添加子部门）
  roleUpdateDept: "ROLE_UpdateDept",
  //模块管理员管理（添加/删除）
  roleSubAdminUserManage: "ROLE_SubAdminUserManage",
  //权限配置(保存按钮)
  roleSubAdminAuthorityManage: "ROLE_SubAdminAuthorityManage",
  //角色成员管理（添加/删除）
  roleBizRoleUserManage: "ROLE_BizRoleUserManage",
  //新增/删除流程
  roleAddDelApproveSetting: "ROLE_AddDelApproveSetting",
  //保存流程
  roleSavePropertyApproveSetting: "ROLE_SavePropertyApproveSetting",
  //导入资产
  roleUploadProperty: "ROLE_UploadProperty",
  //资产编辑
  roleUpdateProperty: "ROLE_UpdateProperty",
  //位置信息
  rolePropertyLocation: "ROLE_PropertyLocation",
  //资产导出
  roleDownloadProperty: "ROLE_DownloadProperty",
  //资产报废
  roleDelProperty: "ROLE_DelProperty",
  //记录导出
  roleDownloadApplicationProperty: "ROLE_DownloadApplicationProperty",
  //新建/编辑模板
  roleAddSalaryTemplate: "ROLE_AddSalaryTemplate",
  //删除/重命名/新增分类
  roleDelRenameAddSalaryTemplateCategory: "ROLE_DelRenameAddSalaryTemplateCategory",
  //添加细项
  roleAddDetails: "ROLE_AddDetails",
  //编辑解读内容
  roleUpdateInterpretationContent: "ROLE_UpdateInterpretationContent",
  //新增制表
  roleAddSalaryTable: "ROLE_AddSalaryTable",
  //工薪操作（所有其他按钮归集, 包含编辑&作废&发送&撤回）
  roleSalaryMethodBotton: "ROLE_SalaryMethodBotton",
  //新增工薪流程
  roleAddSalaryApproveSetting: "ROLE_AddSalaryApproveSetting",
  //保存工薪流程
  roleSaveSalaryApproveSetting: "ROLE_SaveSalaryApproveSetting",
  //创建食堂
  roleAddCanteen: "ROLE_AddCanteen",
  //编辑食堂(包含服务范围修改）
  roleUpdateCanteen: "ROLE_UpdateCanteen",
  //删除食堂
  roleDelCanteen: "ROLE_DelCanteen",
  //新增/重命名/删除物料分类
  roleAddRenameDelMaterialCategory: "ROLE_AddRenameDelMaterialCategory",
  //新增/删除物料
  roleAddDelMaterial: "ROLE_AddDelMaterial",
  //供应商创建
  roleAddSupplier: "ROLE_AddSupplier",
  //供应商操作（包含编辑、修改密码、冻结、删除）
  roleSupplierMethod: "ROLE_SupplierMethod",
  //菜单发布
  roleUpdateMenu: "ROLE_UpdateMenu",
  //物料领用
  roleApplyMaterial: "ROLE_ApplyMaterial",
  //帮厨设置
  roleHelpChiefSetting: "ROLE_HelpChiefSetting",
  //添加报销单据
  roleAddReimburseForm: "ROLE_AddReimburseForm",
  //编辑报销单据（包含 保存、打印模板）
  roleUpdateReimburseForm: "ROLE_UpdateReimburseForm",
  //编辑预审批分类（包含新增分类、新增单据）
  roleAddPreApprovalType: "ROLE_AddPreApprovalType",
  //预审批单据编辑(包含 编辑、打印模板)
  roleUpdatePreApprovalForm: "ROLE_UpdatePreApprovalForm",
  //费用单编辑
  roleUpdateBillForm: "ROLE_UpdateBillForm",
  //新增流程
  roleAddApproveSetting: "ROLE_AddApproveSetting",
  //流程编辑（保存、删除）
  roleUpdateApproveSetting: "ROLE_UpdateApproveSetting",
}

export const operationMixins = {
  data() {
    return {
      OPERATION_LIST,
      OPERATIONS_BTNS
    }
  }
}